import React, { Children } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Nunca pensé que un plan así existiera. Ahora sé que mis hijos están protegidos pase lo que pase.',
  author: 'María G.',
  role: 'Madre de 3'
}, {
  quote: 'Dejé de guardar dinero debajo del colchón. Hoy tengo un plan real para mi retiro.',
  author: 'Carlos R.',
  role: 'Trabajador independiente'
}, {
  quote: 'Lo mejor fue entender que no es un gasto, es una inversión en mi familia.',
  author: 'Ana y Pedro',
  role: 'Pareja joven'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-102">
      {/* Blurred Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-103">
        <div className="absolute inset-0 bg-magi-navy/80 backdrop-blur-sm" data-id="element-104" />
      </div>

      <div className="relative z-10 container mx-auto px-6 md:px-12" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-4" data-id="element-107">
            Familias que ya tomaron acción
          </h2>
          <div className="w-24 h-1 bg-magi-beige mx-auto rounded-full" data-id="element-108" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-109">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-2xl text-white shadow-xl" data-id="element-110">
              <svg className="w-8 h-8 text-magi-beige/60 mb-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-111">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-112" />
              </svg>
              <p className="text-lg font-light leading-relaxed mb-6 italic" data-id="element-113">
                "{testimonial.quote}"
              </p>
              <div data-id="element-114">
                <p className="font-semibold text-magi-beige" data-id="element-115">
                  {testimonial.author}
                </p>
                <p className="text-sm text-gray-300 font-light" data-id="element-116">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}